import { DepartmentQueryParams } from '../types/department';

const SCOPE_KEYS = ['churchId', 'districtId', 'nationId'] as const;

export function buildDepartmentQueryPath(params: DepartmentQueryParams): string {
  if (params.churchId) return `church/${params.churchId}/department/query`;
  if (params.districtId) return `district/${params.districtId}/department/query`;
  if (params.nationId) return `nation/${params.nationId}/department/query`;
  return 'department/query';
}

/** Build scope query params for backends that expect scope + scope_ref_id on department/query. */
function scopeQueryParams(params: DepartmentQueryParams): Record<string, string> {
  if (params.churchId) return { scope: 'church', scope_ref_id: String(params.churchId) };
  if (params.districtId) return { scope: 'district', scope_ref_id: String(params.districtId) };
  if (params.nationId) return { scope: 'nation', scope_ref_id: String(params.nationId) };
  return {};
}

/**
 * Serialize department list query params. Repeats `actionCodes[]` instead of
 * joining the array into a single comma-separated value.
 */
export function buildDepartmentQueryString(params: DepartmentQueryParams): string {
  const query = new URLSearchParams();
  const path = buildDepartmentQueryPath(params);
  if (path === 'department/query') {
    Object.entries(scopeQueryParams(params)).forEach(([key, value]) => {
      query.set(key, value);
    });
  }

  (Object.entries(params) as Array<[keyof DepartmentQueryParams, unknown]>).forEach(([key, value]) => {
    if (SCOPE_KEYS.includes(key as (typeof SCOPE_KEYS)[number])) return;
    if (key === 'actionCodes') return;
    if (value === undefined || value === null || value === '') return;
    query.set(String(key), typeof value === 'boolean' ? (value ? '1' : '0') : String(value));
  });

  for (const code of params.actionCodes ?? []) {
    if (!code) continue;
    query.append('actionCodes[]', code);
  }

  return query.toString();
}
